
<ion-header
  id="primary-header">
  <tidy-wrapper
      [ngClass]="{
        'primary-menu': true,
        'only-icons-wrapper-width': menu.showSecondaryMenu || isMenuCollapsed
      }"
    [isMenu]="true"
    id="primary-menu"
    class="overflow-container">

    <!-- User Profile Section -->
    <div class="user-profile-section">
      <div class="user-profile-content">
        <div class="user-info" (click)="toggleUserDropdown($event)" #userIconRef>
          <div class="user-initials">{{initials || 'G'}}</div>
          <tidy-text [navTitle]="userName || 'Guest'" class="user-name" />
          <img src="assets/svg/chevron-down-outline.svg" class="dropdown-arrow" />
        </div>
        <div class="nav-icons">
          <div class="nav-icon" (click)="openSearch()">
            <img src="assets/img/search-header.svg" class="nav-icon-img" />
          </div>
          <div class="nav-icon" (click)="navigateToNotificationCenter()">
            <div class="notification-wrapper">
              <img src="assets/img/notification-white.svg" class="nav-icon-img" />
              @if (notificationCount > 0 && notificationCount < 10) {
                <div class="notification-badge">{{notificationCount}}</div>
              }
              @if (notificationCount >= 10) {
                <div class="notification-badge">9+</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (showUserDropdown) {
      <div #userDropdownRef class="user-dropdown">
        <div class="user-dropdown-list">
          <div class="user-dropdown-item" [attr.data-testid]="'user-dropdown-contact-info'" (click)="goToContactInfo()">
            <tidy-text [body]="'Contact Info'" />
          </div>
          <div class="user-dropdown-item" [attr.data-testid]="'user-dropdown-subscription'" (click)="goToSubscriptionPage()">
            <tidy-text [body]="'Subscription'" />
          </div>
          <!--<div class="user-dropdown-item" (click)="goToDemo()">
            <tidy-text [body]="'Demo'" />
          </div>-->
          <div class="user-dropdown-item" [attr.data-testid]="'user-dropdown-logout'" (click)="logout()">
            <tidy-text [body]="'Logout'" />
          </div>
        </div>
      </div>
    }

      @if (menuItems && menuRenderVisible) {
        <div class="nav-menu-items">

          @if (isRentalClient) {
          <!-- Chat -->
          <button
            type="button"
            class="nav-item"
            [class.nav-item--active]="isChatActive"
            [attr.data-testid]="'nav-chat'"
            (click)="goToLink('/chat')">
            <span class="nav-item__icon">
              <span class="nav-item__icon-img"
                [style.-webkit-mask-image]="'url(assets/svg/chatbubble-ellipses-outline.svg)'"
                [style.mask-image]="'url(assets/svg/chatbubble-ellipses-outline.svg)'"></span>
            </span>
            <span class="nav-item__label">{{ 'Chat' | translate }}</span>
          </button>

          <!-- Overview (the P&L page) — promoted out of the Finance section -->
          <button
            type="button"
            class="nav-item"
            [class.nav-item--active]="isOverviewActive"
            [attr.data-testid]="'nav-strategy'"
            (click)="goToLink('/overview')">
            <span class="nav-item__icon">
              <span class="nav-item__icon-img"
                [style.-webkit-mask-image]="'url(assets/svg/grid-outline.svg)'"
                [style.mask-image]="'url(assets/svg/grid-outline.svg)'"></span>
            </span>
            <span class="nav-item__label">{{ 'Overview' | translate }}</span>
          </button>

          <!-- Schedule — promoted out of the Operations section -->
          @if (scheduleNavItem) {
            <button
              type="button"
              class="nav-item"
              [class.nav-item--active]="isScheduleActive"
              [attr.data-testid]="'nav-schedule'"
              (click)="goToLink('/schedule')">
              <span class="nav-item__icon">
                <span class="nav-item__icon-img"
                  [style.-webkit-mask-image]="'url(' + scheduleNavItem.icon + ')'"
                  [style.mask-image]="'url(' + scheduleNavItem.icon + ')'"></span>
              </span>
              <span class="nav-item__label">{{ 'Schedule' | translate }}</span>
            </button>
          }

          <!-- Root-level items (Assets, Agents) -->
          @for (item of rootItems; track item.target) {
            @if (item.label !== 'More') {
              <button
                type="button"
                class="nav-item"
                [class.nav-item--active]="item._hasBackgroundEffect"
                [attr.data-testid]="'nav-' + item.target"
                (click)="goToLink(item.target)">
                <span class="nav-item__icon">
                  <span class="nav-item__icon-img"
                    [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                    [style.mask-image]="'url(' + item.icon + ')'"></span>
                </span>
                <span class="nav-item__label">{{ item.label | translate }}</span>
              </button>
            }
          }

          <!-- Revenue (formerly Marketing) section -->
          @if (hasMarketingSection) {
            <div class="nav-section">
              <button
                type="button"
                class="nav-section__header"
                [attr.data-testid]="'nav-section-marketing'"
                (click)="openMarketingSection()">
                <span class="nav-section__icon">
                  <span class="nav-section__icon-img"
                    [style.-webkit-mask-image]="'url(assets/svg/megaphone-outline.svg)'"
                    [style.mask-image]="'url(assets/svg/megaphone-outline.svg)'"></span>
                </span>
                <span class="nav-section__label">{{ marketingSection.label | translate }}</span>
                <img
                  src="assets/svg/chevron-down-outline.svg"
                  class="nav-section__chevron"
                  [class.nav-section__chevron--open]="marketingMenuExpanded" />
              </button>
              @if (marketingMenuExpanded) {
                <div class="nav-subitems">
                  @for (item of marketingItems; track item.tab) {
                    <button
                      type="button"
                      class="nav-subitem"
                      [class.nav-subitem--active]="item._isCurrentItem"
                      [attr.data-testid]="'nav-marketing-' + item.tab"
                      (click)="item.isOverview ? goToLink(item.route) : goToTab('/revenue', item.tab)">
                      <span class="nav-subitem__dot"></span>
                      <span class="nav-subitem__icon">
                        <span class="nav-subitem__icon-img"
                          [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                          [style.mask-image]="'url(' + item.icon + ')'"></span>
                      </span>
                      <span class="nav-subitem__label">{{ item.label | translate }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }

          <!-- Operations section (Agents sits at the bottom of the sub-items) -->
          <div class="nav-section">
            <button
              type="button"
              class="nav-section__header"
              [attr.data-testid]="'nav-section-operations'"
              (click)="openOperationsSection()">
              <span class="nav-section__icon">
                <span class="nav-section__icon-img"
                  [style.-webkit-mask-image]="'url(assets/svg/construct-outline.svg)'"
                  [style.mask-image]="'url(assets/svg/construct-outline.svg)'"></span>
              </span>
              <span class="nav-section__label">{{ operationsSection.label | translate }}</span>
              <img
                src="assets/svg/chevron-down-outline.svg"
                class="nav-section__chevron"
                [class.nav-section__chevron--open]="operationsMenuExpanded" />
            </button>
            @if (operationsMenuExpanded) {
              <div class="nav-subitems">
                @for (item of operationsItems; track item.target) {
                  <button
                    type="button"
                    class="nav-subitem"
                    [class.nav-subitem--active]="item._hasBackgroundEffect"
                    [attr.data-testid]="'nav-' + item.target"
                    (click)="goToLink(item.target)">
                    <span class="nav-subitem__dot"></span>
                    <span class="nav-subitem__icon">
                      <span class="nav-subitem__icon-img"
                        [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                        [style.mask-image]="'url(' + item.icon + ')'"></span>
                      @if (item.showAgentIndicator && agentSettings?.[item.key] === true) {
                        <span class="nav-agent-indicator active small">
                          <span class="shimmer-effect"></span>
                        </span>
                      }
                    </span>
                    <span class="nav-subitem__label">{{ item.label | translate }}</span>
                  </button>
                }
              </div>
            }
          </div>

          <!-- Finance section -->
          @if (hasFinanceSection) {
            <div class="nav-section">
              <button
                type="button"
                class="nav-section__header"
                [attr.data-testid]="'nav-section-finance'"
                (click)="openFinanceSection()">
                <span class="nav-section__icon">
                  <span class="nav-section__icon-img"
                    [style.-webkit-mask-image]="'url(assets/svg/wallet-outline.svg)'"
                    [style.mask-image]="'url(assets/svg/wallet-outline.svg)'"></span>
                </span>
                <span class="nav-section__label">{{ financeSection.label | translate }}</span>
                <img
                  src="assets/svg/chevron-down-outline.svg"
                  class="nav-section__chevron"
                  [class.nav-section__chevron--open]="financeMenuExpanded" />
              </button>
              @if (financeMenuExpanded) {
                <div class="nav-subitems">
                  @for (item of financeItems; track item.tab) {
                    <button
                      type="button"
                      class="nav-subitem"
                      [class.nav-subitem--active]="item._isCurrentItem"
                      [attr.data-testid]="'nav-finance-' + item.tab"
                      (click)="item.isOverview ? goToLink(item.route) : goToTab('/finance', item.tab)">
                      <span class="nav-subitem__dot"></span>
                      <span class="nav-subitem__icon">
                        <span class="nav-subitem__icon-img"
                          [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                          [style.mask-image]="'url(' + item.icon + ')'"></span>
                      </span>
                      <span class="nav-subitem__label">{{ item.label | translate }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }

          <!-- Properties — promoted out of the Operations section -->
          <button
            type="button"
            class="nav-item"
            [class.nav-item--active]="isPropertiesActive"
            [attr.data-testid]="'nav-properties'"
            (click)="goToLink('/properties')">
            <span class="nav-item__icon">
              <span class="nav-item__icon-img"
                [style.-webkit-mask-image]="'url(assets/svg/home-outline.svg)'"
                [style.mask-image]="'url(assets/svg/home-outline.svg)'"></span>
            </span>
            <span class="nav-item__label">{{ 'Properties' | translate }}</span>
          </button>

          <!-- More link -->
          <button
            type="button"
            class="nav-item"
            [class.nav-item--active]="router.url.startsWith('/more')"
            [attr.data-testid]="'nav-more'"
            (click)="goToLink('/more')">
            <span class="nav-item__icon">
              <span class="nav-item__icon-img"
                [style.-webkit-mask-image]="'url(assets/svg/ellipsis-horizontal-outline.svg)'"
                [style.mask-image]="'url(assets/svg/ellipsis-horizontal-outline.svg)'"></span>
            </span>
            <span class="nav-item__label">{{ 'More' | translate }}</span>
          </button>
          } @else {
            <!-- Non-rental clients: same BEM `.nav-item` markup as rental,
                 just rendered flat (no Finance / Revenue / Operations
                 expandable sections). This way the residential nav inherits
                 the rental design — icon-grow hover, blue icon+label
                 highlight, no per-row strokes — instead of the legacy
                 tidy-card-button look. -->
            <!-- Chat -->
            <button
              type="button"
              class="nav-item"
              [class.nav-item--active]="isChatActive"
              [attr.data-testid]="'nav-chat'"
              (click)="goToLink('/chat')">
              <span class="nav-item__icon">
                <span class="nav-item__icon-img"
                  [style.-webkit-mask-image]="'url(assets/svg/chatbubble-ellipses-outline.svg)'"
                  [style.mask-image]="'url(assets/svg/chatbubble-ellipses-outline.svg)'"></span>
              </span>
              <span class="nav-item__label">{{ 'Chat' | translate }}</span>
            </button>

            <!-- Flat residential menu items (Overview, Schedule, Messages,
                 Checklists, Pros, Agents, …) — More is handled below. -->
            @for (item of menuItems; track item.target) {
              @if (item.label !== 'More') {
                <button
                  type="button"
                  class="nav-item"
                  [class.nav-item--active]="item._hasBackgroundEffect"
                  [attr.data-testid]="'nav-' + item.target"
                  (click)="goToLink(item.target)">
                  <span class="nav-item__icon">
                    <span class="nav-item__icon-img"
                      [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                      [style.mask-image]="'url(' + item.icon + ')'"></span>
                    @if (item.showAgentIndicator && agentSettings?.[item.key] === true) {
                      <span class="nav-agent-indicator active small">
                        <span class="shimmer-effect"></span>
                      </span>
                    }
                  </span>
                  <span class="nav-item__label">{{ item.label | translate }}</span>
                </button>
              }
            }

            <!-- More -->
            <button
              type="button"
              class="nav-item"
              [class.nav-item--active]="router.url.startsWith('/more')"
              [attr.data-testid]="'nav-more'"
              (click)="goToLink('/more')">
              <span class="nav-item__icon">
                <span class="nav-item__icon-img"
                  [style.-webkit-mask-image]="'url(assets/svg/ellipsis-horizontal-outline.svg)'"
                  [style.mask-image]="'url(assets/svg/ellipsis-horizontal-outline.svg)'"></span>
              </span>
              <span class="nav-item__label">{{ 'More' | translate }}</span>
            </button>

            <!-- Help section (collapsible like Marketing / Operations / Finance). -->
            <div class="nav-section">
              <button
                type="button"
                class="nav-section__header"
                [attr.data-testid]="'nav-section-help'"
                (click)="toggleHelpMenu($event)">
                <span class="nav-section__icon">
                  <span class="nav-section__icon-img"
                    [style.-webkit-mask-image]="'url(assets/svg/help-circle-outline.svg)'"
                    [style.mask-image]="'url(assets/svg/help-circle-outline.svg)'"></span>
                </span>
                <span class="nav-section__label">{{ 'Help' | translate }}</span>
                <img
                  src="assets/svg/chevron-down-outline.svg"
                  class="nav-section__chevron"
                  [class.nav-section__chevron--open]="helpMenuExpanded" />
              </button>
              @if (helpMenuExpanded) {
                <div class="nav-subitems">
                  <button
                    type="button"
                    class="nav-subitem"
                    [attr.data-testid]="'nav-help-whats-new'"
                    (click)="openWhatsNew()">
                    <span class="nav-subitem__dot"></span>
                    <span class="nav-subitem__icon">
                      <span class="nav-subitem__icon-img"
                        [style.-webkit-mask-image]="'url(assets/svg/newspaper-outline.svg)'"
                        [style.mask-image]="'url(assets/svg/newspaper-outline.svg)'"></span>
                    </span>
                    <span class="nav-subitem__label">What's New?</span>
                  </button>
                  <button
                    type="button"
                    class="nav-subitem"
                    [attr.data-testid]="'nav-help-documentation'"
                    (click)="openDocumentation()"
                    (mousedown)="startLongPress()"
                    (mouseup)="endLongPress()"
                    (mouseleave)="endLongPress()"
                    (touchstart)="startLongPress()"
                    (touchend)="endLongPress()">
                    <span class="nav-subitem__dot"></span>
                    <span class="nav-subitem__icon">
                      <span class="nav-subitem__icon-img"
                        [style.-webkit-mask-image]="'url(assets/svg/book-outline.svg)'"
                        [style.mask-image]="'url(assets/svg/book-outline.svg)'"></span>
                    </span>
                    <span class="nav-subitem__label">{{ showAppVersion ? 'v' + appVersion : ('Documentation' | translate) }}</span>
                  </button>
                  <button
                    type="button"
                    class="nav-subitem"
                    [attr.data-testid]="'nav-help-terms'"
                    (click)="openTerms()">
                    <span class="nav-subitem__dot"></span>
                    <span class="nav-subitem__icon">
                      <span class="nav-subitem__icon-img"
                        [style.-webkit-mask-image]="'url(assets/svg/document-text-outline.svg)'"
                        [style.mask-image]="'url(assets/svg/document-text-outline.svg)'"></span>
                    </span>
                    <span class="nav-subitem__label">{{ 'Terms' | translate }}</span>
                  </button>
                </div>
              }
            </div>
          }

          <!-- Status Indicators -->
          <div class="status-indicators">
            @if (!isEmployerAccount && !isGuestAccount && subscription?.trial_days_left > 0) {
              <div class="status-indicator" (click)="goToSubscriptionPageFromIndicator()">
                <tidy-image [src]="'assets/img/crown.svg'" style="width: 14px; height: 14px; flex-shrink: 0;" />
                <tidy-text [body]="subscription?.trial_days_left + (subscription?.trial_days_left == 1 ? (' Day' | translate) : (' Days' | translate)) + (' Left in Free Trial' | translate)" class="white" />
              </div>
            }
            @if (!isEmployerAccount && (hasNegativeBalance || isAccountSuspended)) {
              <div class="status-indicator warning" (click)="goToSubscriptionPageFromIndicator()">
                <tidy-image [src]="'assets/img/white-alert.svg'" style="width: 14px; height: 14px; flex-shrink: 0;" />
                <tidy-text [body]="hasNegativeBalance ? 'Subscription Payment Issue' : 'Plan Canceled Due to Payment Issue'" class="white" />
              </div>
            }
          </div>

          @if (isDemoAccount) {
            <button
              type="button"
              class="demo-signin-card"
              [attr.data-testid]="'nav-demo-signin'"
              (click)="goToSignInFromDemo()">
              <span class="demo-signin-card__inner">
                <span class="demo-signin-card__text">
                  <tidy-text [helper]="'Already have an account?'" />&ngsp;<tidy-text [body]="'Sign In'" class="white-link" />
                </span>
              </span>
            </button>
          }

        </div>
      }
    </tidy-wrapper>
  </ion-header>
